module.exports = __webpack_public_path__ + "static/media/successTick.bc8162bf.svg";